import axios from "axios";

import { CHECK_FILE, CREATE_FIVES_FOURS, CHECK_FOURS, CREATE_FOURS, CHECK_FIVE, CREATE_FIVE, CHECKER_SET_LOADING, CHECKER_ERROR} from './types'

//check file
export const validateFile = (fileID) => async (dispatch) => {
  dispatch({ type: CHECKER_SET_LOADING })

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  config.headers.Authorization = "JWT " + localStorage.getItem("token");

  try {
    const response = await axios.get(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/filechecker/`, config);

    dispatch({
      type: CHECK_FILE,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: CHECKER_ERROR })
  }
}

export const createFoursFives = (fileID) => async (dispatch) => {
  dispatch({ type: CHECKER_SET_LOADING })

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  config.headers.Authorization = "JWT " + localStorage.getItem("token");

  try {
    const response = await axios.post(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/missingfourandfivecreator/`, null, config);

    dispatch({
      type: CREATE_FIVES_FOURS,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: CHECKER_ERROR })
  }
}

///////////////////////////////////////////////////////////////////////////////
// check Fours
export const checkFours = (fileID) => async (dispatch) => {
    dispatch({ type: CHECKER_SET_LOADING })

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.get(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/missingfourchecker/`, config);

    dispatch({
      type: CHECK_FOURS,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: CHECKER_ERROR })
  }
}

// check Fours
export const checkFives = (fileID) => async (dispatch) => {
    dispatch({ type: CHECKER_SET_LOADING })

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.get(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/missingfiveschecker/`, config);

    dispatch({
      type: CHECK_FIVE,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: CHECKER_ERROR })
  }
}

// Create Fours
export const createFives = (fileID) => async (dispatch) => {
    dispatch({ type: CHECKER_SET_LOADING })

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.post(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/missingfivescreator/`,null, config);

    dispatch({
      type: CREATE_FIVE,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: CHECKER_ERROR })
  }

}

// Create Fours
export const createFours = (fileID) => async (dispatch) => {
    dispatch({ type: CHECKER_SET_LOADING })

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.post(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/missingfourcreator/`,null, config);

    dispatch({
      type: CREATE_FOURS,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: CHECKER_ERROR })
  }
}

